export const drawerWidth = 305;

export const styles = theme => ({
    /*All*/
    appBar: { // The width of the AppBar changes depending on the drawer
        marginLeft: drawerWidth,
        [theme.breakpoints.up('sm')]: { 
            width: `calc(100% - ${drawerWidth}px)`,
        },
    },

    card: {
        padding: "30px",
        marginLeft: 'auto',
        marginRight: 'auto',
    },

    logoContainer: {
        width: "100%",
        display: "grid", 
        placeItems: "center", 
        marginTop: "0.2em",
        [theme.breakpoints.up('sm')]: {
            placeItems: "flex-start",     
            marginTop: 0, 
        }        
    },

    logo: {
        width: "6em",
        marginLeft: "0",
        [theme.breakpoints.up('sm')]: {
            marginLeft: "2em",
        },
        marginTop: "0.2em",
        marginBottom: "0.2em",
    },

    toolbar: theme.mixins.toolbar,

    /*Homescreen*/
    content: {
        flexGrow: 1,
        padding: theme.spacing(1.5),
    },

    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },

    drawerPaper: {
        width: drawerWidth,
    },

    menuButton: {
        position: "fixed",
        top: "0.25em", 
        left: "0.5em",
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },

    popup_background: {
        zIndex: 1500,
        position: "fixed",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.25)",
    },

    popup: {
        width: "100%",
        backgroundColor: "white",
        position: "center"
    },

    root: {
        display: 'flex',
    },

    titleWidget: {
        fontWeight: "bold",
    },

    widget: {
        marginTop: "0.7em",
        padding: "10px",
        textAlign: "center",
        minHeight: "24.2em"
    },

    /*Profile*/
    informations: {
        fontWeight: "650",
        fontFamily: "Roboto"
    },
    
    profilePic: {
        width: "90%",
        height: "90%",
        maxWidth: "140px",
        maxHeight: "160px"
    },
});